import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Button,
  CircularProgress,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import useSWR from 'swr';
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import { exportStyledExcel, pdfTableTheme } from '../../utils/exportHelpers';
import { apiHost } from '../../utils/apiHost';

const fetcher = (url) => axios.get(url, { withCredentials: true }).then((res) => res.data);

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

export const StockPerCabang = () => {
  const { user } = useSelector((state) => state.auth);
  const [selectedCabang, setSelectedCabang] = useState('');

  const { data: cabangList } = useSWR(
    user?.role === 'superadmin' ? `${getApiBaseUrl()}/cabang` : null,
    fetcher
  );

  const apiUrl = `${getApiBaseUrl()}/stok-per-cabang${selectedCabang ? `?cabangUuid=${selectedCabang}` : ''}`;
  const { data, error } = useSWR(user ? apiUrl : null, fetcher);

  // Handle loading state
  if (!data) return <CircularProgress />;
  if (error) return <Typography color="error">Gagal mengambil data.</Typography>;

  const { data: stockData } = data;

  // Fungsi untuk export PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Laporan Stok per Cabang", 10, 10);

    const tableColumn = ["Cabang", "Alamat", "Nama Barang", "Kategori", "Harga", "Stok"];
    const tableRows = stockData.map(({ cabang, alamatCabang, namaBarang, kategori, harga, stok }) => [
      cabang, alamatCabang, namaBarang, kategori, harga.toLocaleString(), stok
    ]);

    doc.autoTable({
      startY: 20,
      head: [tableColumn],
      body: tableRows,
      ...pdfTableTheme,
    });

    doc.save("stok_per_cabang.pdf");
  };

  const exportToExcel = async () => {
    const rows = stockData.map(({ cabang, alamatCabang, namaBarang, kategori, harga, stok }) => [
      cabang, alamatCabang, namaBarang, kategori, harga, stok
    ]);
    await exportStyledExcel({
      fileName: 'stok_per_cabang.xlsx',
      sheetName: 'Stok Per Cabang',
      title: 'Laporan Stok per Cabang',
      headers: ['Cabang', 'Alamat', 'Nama Barang', 'Kategori', 'Harga', 'Stok'],
      rows,
      columnWidths: [20, 30, 30, 18, 14, 10],
    });
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Laporan Stok per Cabang
      </Typography>

      <Grid container spacing={2} alignItems="center">
        {user?.role === 'superadmin' && (
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Filter Cabang</InputLabel>
              <Select
                value={selectedCabang}
                onChange={(e) => setSelectedCabang(e.target.value)}
                label="Filter Cabang"
              >
                <MenuItem value="">
                  <em>Semua Cabang</em>
                </MenuItem>
                {cabangList?.data?.map((cabang) => (
                  <MenuItem key={cabang.uuid} value={cabang.uuid}>
                    {cabang.namacabang}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item>
          <Button variant="contained" color="primary" onClick={exportToPDF}>
            Export PDF
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="success" onClick={exportToExcel}>
            Export Excel
          </Button>
        </Grid>
      </Grid>

      {/* Table Container untuk Scroll */}
      <TableContainer component={Paper} sx={{ mt: 3, p: 2, overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Cabang</b></TableCell>
              <TableCell><b>Alamat</b></TableCell>
              <TableCell><b>Nama Barang</b></TableCell>
              <TableCell><b>Kategori</b></TableCell>
              <TableCell><b>Harga</b></TableCell>
              <TableCell><b>Stok</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stockData.length > 0 ? (
              stockData.map((row) => (
                <TableRow key={row.barangId}>
                  <TableCell>{row.cabang}</TableCell>
                  <TableCell>{row.alamatCabang}</TableCell>
                  <TableCell>{row.namaBarang}</TableCell>
                  <TableCell>{row.kategori}</TableCell>
                  <TableCell>Rp {row.harga.toLocaleString()}</TableCell>
                  <TableCell>{row.stok}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">Tidak ada data</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
